import { render, staticRenderFns } from "./DeleteCategoryPropertyModal.vue?vue&type=template&id=77035ecc&scoped=true"
import script from "./DeleteCategoryPropertyModal.vue?vue&type=script&lang=js"
export * from "./DeleteCategoryPropertyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77035ecc",
  null
  
)

export default component.exports